import { render } from "./MigrateVolume.vue?vue&type=template&id=2913fbdf&scoped=true"
import script from "./MigrateVolume.vue?vue&type=script&lang=js"
export * from "./MigrateVolume.vue?vue&type=script&lang=js"

import "./MigrateVolume.vue?vue&type=style&index=0&id=2913fbdf&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2913fbdf"]])

export default __exports__